import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/ui/checkbox'
import type { Proposal } from '@/services/api/structuredIngest'
import { withRowTextExtraction } from './text-extraction'

export function RowTextExtractionOptions({
  recipe,
  columns,
  disabled,
  onChange,
}: {
  recipe: Proposal
  columns: string[]
  disabled: boolean
  onChange: (recipe: Proposal) => void
}) {
  const { t } = useTranslation()
  const available = [...new Set([...columns, ...(recipe.derived_columns ?? []).map(c => c.name)])]
  if (!available.length) return null
  return (
    <fieldset disabled={disabled} className="rounded-md border bg-muted/30 p-3">
      <legend className="px-1 text-sm font-medium">{t('tableMapping.extraction.rowTitle')}</legend>
      <p className="mb-3 text-xs text-muted-foreground">
        {t('tableMapping.extraction.rowDescription')}
      </p>
      <div className="flex flex-col gap-2">
        {available.map(column => (
          <label key={column} className="flex items-center gap-2 text-xs">
            <Checkbox
              checked={recipe.row_text_columns?.includes(column) ?? false}
              disabled={disabled}
              onCheckedChange={checked =>
                onChange(withRowTextExtraction(recipe, column, checked === true))
              }
            />
            <span className="font-mono">{column}</span>
          </label>
        ))}
      </div>
    </fieldset>
  )
}
